export default "__VITE_ASSET__02f2576c__"